import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { slideFromLeft, useWdInView } from "./WdMotion";

const typingPhrases = [
    "Editing homepage hero…",
    "Uploading new banner image…",
    "Publishing blog draft…",
    "Saving page changes…",
];

export const WdCmsSection = () => {
    const { ref, inView } = useWdInView();
    const [typed, setTyped] = useState("");
    const [phraseIdx, setPhraseIdx] = useState(0);

    useEffect(() => {
        if (!inView) {
            setTyped("");
            setPhraseIdx(0);
            return;
        }

        const phrase = typingPhrases[phraseIdx];
        let char = 0;
        setTyped("");

        const typeTimer = setInterval(() => {
            char += 1;
            setTyped(phrase.slice(0, char));
            if (char >= phrase.length) {
                clearInterval(typeTimer);
                setTimeout(() => setPhraseIdx((p) => (p + 1) % typingPhrases.length), 900);
            }
        }, 45);

        return () => clearInterval(typeTimer);
    }, [inView, phraseIdx]);

    return (
        <section className="wd-section wd-cms" ref={ref}>
            <div className="wd-container wd-cms__grid wd-layout--reverse">
                <div className="wd-cms__copy">
                    <div className="wd-section-header">
                        <h2 className="wd-section-title">CMS Website</h2>
                        <p className="wd-section-subtitle">
                            Content can be managed by{" "}
                            <span className="wd-accent">Admin Panel</span>
                        </p>
                    </div>
                    <p className="wd-section-desc">
                        Manage your website content effortlessly through a secure admin dashboard.
                        Update text, images, blogs, services, and pages without requiring technical
                        knowledge. Ideal for businesses that need frequent content updates and team
                        collaboration.
                    </p>
                </div>

                <motion.div
                    className="wd-cms__visual"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.25 }}
                    variants={slideFromLeft}
                >
                    <div className="wd-cms__dashboard">
                        <div className="wd-cms__dash-top">
                            <span className="wd-dot wd-dot--red" />
                            <span className="wd-dot wd-dot--amber" />
                            <span className="wd-dot wd-dot--green" />
                            <span className="wd-cms__dash-title">Content Admin</span>
                        </div>
                        <div className="wd-cms__dash-body">
                            <div className="wd-cms__sidebar">
                                {["Pages", "Blog", "Media", "Settings"].map((item, i) => (
                                    <div
                                        key={item}
                                        className={`wd-cms__nav-item${i === 0 ? " is-active" : ""}`}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                            <div className="wd-cms__editor">
                                <div className="wd-cms__editor-bar" />
                                <div className="wd-cms__editor-line wd-cms__editor-line--wide" />
                                <div className="wd-cms__editor-line" />
                                <div className="wd-cms__editor-line wd-cms__editor-line--short" />
                                <div className="wd-cms__typing">
                                    <span className="wd-cms__cursor">|</span>
                                    {typed}
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
